import ViewListIcon from '@material-ui/icons/ViewList';

import { OrdersByAPIKeysList } from './List/List';


export const ordersByAPIKeysResource = {
	list: OrdersByAPIKeysList,
	icon: ViewListIcon,
}
